import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { syncPushSubscription } from '../push';

/**
 * Signed-in plumbing for notifications: keeps this device's subscription registered, and opens
 * the page a clicked notification points to without reloading the app.
 */
export function PushBridge({ userId }: { userId: string }) {
  const navigate = useNavigate();

  useEffect(() => {
    syncPushSubscription(userId).catch(() => undefined);
  }, [userId]);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { type?: unknown; url?: unknown } | null;
      if (data?.type !== 'NAVIGATE' || typeof data.url !== 'string') return;
      // Same-origin paths only ("/c/…"); never "//host" or a scheme.
      if (!data.url.startsWith('/') || data.url.startsWith('//')) return;
      navigate(data.url);
    };
    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, [navigate]);

  return null;
}
